module.exports = __webpack_public_path__ + "static/monash_logo-d0cfd5fe26777c9ebabd499c73be2077.png";